export default class Models {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        const menuOpen = document.querySelector('#filter__menu__open');
        const menuClose = document.querySelector('#filter__menu__close');
        const formReset = document.querySelector('#filter__menu__reset');
        const menuForm = document.querySelector('#filter__form');
        const menu = document.querySelector('#filter__menu');

        menuOpen.onclick = function () {
            menu.classList.add('filter__menu--open');
        }

        menuClose.onclick = function () {
            menu.classList.remove('filter__menu--open');
            self.resetFilterSlidersDisplay();
        }

        formReset.onclick = function () {
            menuForm.reset();
        }

        const filterValues = document.querySelectorAll('.filter__value__display');
        filterValues.forEach((filterValue) => {
            filterValue.onclick = function () {
                const filterSliders = document.querySelectorAll('#filter-sliders .filter');
                if (menu.classList.contains('filter__menu--open')) {
                    menu.classList.remove('filter__menu--open');
                    self.resetFilterSlidersDisplay();
                } else {
                    menu.classList.add('filter__menu--open');
                    filterSliders.forEach((filterSlider) => {
                        if (filterSlider.id !== filterValue.dataset.id) {
                            filterSlider.style.display = 'none';
                        }
                    });
                }
            }
        });

        document.body.addEventListener("click", function (event) {
            if (!event.target.closest('#filter__menu__open') && !event.target.closest('#filter__menu') && !event.target.closest('.filter__value__display')) {
                menu.classList.remove('filter__menu--open');
                self.resetFilterSlidersDisplay();
            }
        });
    }

    resetFilterSlidersDisplay() {
        const filterSliders = document.querySelectorAll('#filter-sliders .filter');
        filterSliders.forEach((filterSlider) => {
            filterSlider.style.display = 'block';
        });
    }
}